<template>
  <div class="machine-container">
    <div>
      <h1 class="">{{ fit20.selectTabId }} {{ fit20.selectedTabHref }} blocks</h1>
    </div>
    <div class="machines" v-if="fit20[fit20.selectedTabHref + 'Sites']">
      <div :class="['machine-card', { 'selected': block.id == fit20.blockNameToEdit }]"
        v-for="block in fit20[fit20.selectedTabHref + 'Sites']" :key="block.id"
        @click.stop.prevent="getBlock(block.id)">
        <a href="#" :id="block.id">
          <div>{{ block.name }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Blocks',
  components: {},
  props: ["fit20"],
  methods: {
    async getBlock(id) {
      if (id) {
        let getBlock = await fetch(this.fit20.baseUrl + "/api/block/" + id + '?code=' + this.fit20.selectTabId);
        this.fit20.blockToEdit = await getBlock.json();
        this.fit20.originalBlock = JSON.parse(JSON.stringify(this.fit20.blockToEdit));
        this.fit20.blockNameToEdit = id;
      }
    },
  }
};
</script>

<style>
.machine-container h1 {
  color: var(--fit20-blue);
}

.machine-container {
  width: 100%;
  height: 100%;
}

.machine-container .search-add-sec {
  display: flex;
  justify-content: space-between;
}

.machine-container .search-add-sec img {
  width: 50px;
  min-width: 0px;
  min-height: 0px;
}

.machine-container input {
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  padding: 7px 5px;
  width: 40%;
}

.machine-container .machines {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-height: calc(100% - 100px);
  /* Adjust as needed */
  overflow: auto;
  margin-top: 10px;
}

.machine-container .machine-card {
  display: flex;
  margin: 5px;
  border: solid 1px var(--fit20-lighter-gray);
  width: calc(100% / 5 - 20px);
  /* min-height: 40px; */
  border-radius: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
}

.machine-container .selected {
  background-color: var(--fit20-blue);
  color: white !important;
  text-align: center;
  transition: all .8s;
}

.machine-container .selected a {
  color: white !important;
}

.machine-container .machine-card a {
  display: inline-block;
  width: 100%;
  height: 100%;
  /* margin-left: 10px; */
}

/* .machine-container img {
  width: 35%;
  max-width: 110px;
  min-width: 70px;
  min-height: 70px;
} */
</style>
